import React, { useState } from "react";
import { FaChevronDown, FaChevronUp, } from "react-icons/fa";
// import { RiCloseLargeFill } from "react-icons/ri";
import { TiArrowLeftThick } from "react-icons/ti";

import "../../Styles/Employeefilter.css";

function Studentfilter({ show = true, onClose = () => { } }) {

  const [openMenus, setOpenMenus] = useState({});



  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));

    onClose(false);
  };
  if (!show) return null;

  return (
    <div className={`admin-sidebar-filter `}>
      <div className="filter-sidebar-header">
        <button className="close-arrow" onClick={() => onClose(false)}>
          <TiArrowLeftThick />
        </button>
        <span className="filter-dashboard-tit">Filter</span>

      </div>

      <ul className="filter-sidebar-menu">


        {/* University/Autonomous */}
        <li>
          <div className="filter-menu-item" onClick={() => toggleMenu("contact")}>
            <span>University/Autonomous</span>
            {openMenus.contact ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`filter-submenu ${openMenus.contact ? "open" : ""}`}>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Acharya Nagarjuna University</spam>
              </div>
            </li>
            <li className="filter-line-bottom">

              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Jawahaelal Nehru Technological University</spam>
              </div>

            </li>
            <li className="filter-line-bottom">

              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Osmania University</spam>
              </div>

            </li>
            <li className="filter-line-bottom">

             
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Acharya Nagarjuna University, Guntur</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
          
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Sri Venkateswara University, Tirupati</spam>
              </div>

            </li>

          </ul>
        </li>

        {/* College */}
        <li>
          <div
            className="filter-menu-item"
            onClick={() => toggleMenu("registration")}
          >
            <span>College</span>
            {openMenus.registration ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul
            className={`filter-submenu ${openMenus.registration ? "open" : ""}`}
          >
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Government City College (AU)</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Vardhaman College of Engineering(AU)</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
            
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Sri Harshini Degree College</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Kodad Intritute of technology and science for women</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Sri Gowthami Degree & PG College</spam>
              </div>

            </li>

          </ul>
        </li>

        {/* Designation */}
        <li>
          <div className="filter-menu-item" onClick={() => toggleMenu("jobs")}>
            <span>Qualification</span>
            {openMenus.jobs ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`filter-submenu ${openMenus.jobs ? "open" : ""}`}>
            <li className="filter-line-bottom">
              

              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">BTech</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
               
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Degree</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Post Graduation</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">M Tech</spam>
              </div>

            </li>
             <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Others</spam>
              </div>

            </li>

          </ul>
        </li>

        {/* Department */}
        <li>
          <div
            className="filter-menu-item"
            onClick={() => toggleMenu("permission")}>
            <span>Department</span>
            {openMenus.permission ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul
            className={`filter-submenu ${openMenus.permission ? "open" : ""}`}
          >
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">B.com</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
               
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">MBA</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
               
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Master of Business Administration</spam>
              </div>

            </li>

            <li className="filter-line-bottom"> 

              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Student Welfare Department</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Civil Engineering</spam>
              </div>
            </li>
          </ul>
        </li>

        <li>
          <ul >
            
              <li className="filter-line-bottom">
              <div className="text-cont">
                <spam className="text-filter-year">Start year</spam>
                <div>
                  <input className="chech-filter-year1" type="month"></input>
                </div>   
              </div>
            </li>

            <li className="filter-line-bottom">
               <div className="text-cont">
                <spam className="text-filter-year">End year</spam>
                <div>
                  <input className="chech-filter-year2" type="month"></input>
                </div>       
              </div>
            </li>

             
              

          </ul>

        </li>
      </ul>
    </div>
  );
}

export default Studentfilter;
